import React, { useCallback, useMemo, useState, useEffect } from "react";
import { toast } from "react-toastify";
import {
  ArrowDownTrayIcon,
  PresentationChartBarIcon,
} from "@heroicons/react/24/outline";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";

import {
  inventorySparesDownloadFailedRequest,
  inventorySparesRescanRequest,
} from "../../../../http-request/inventory/inventoryDownloadFile";

import {
  selectInventorySpareLotFilterState,
  setInventorySpareLotListFilter,
} from "../../../../store/inventory/inventorySpareLotListSlice";

import { CustomDropdown } from "../../../../component/customdropdown/CustomDropdown";
import classes from "./inventorySparesLotListFilterPage.module.css";

const statuses = [
  { id: "", label: "Select Status" },
  { id: "0", label: "Images Missing" },
  { id: "1", label: "Images Available" },
];

export const InventorySparesLotListFilterPage = () => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const filters = useSelector(selectInventorySpareLotFilterState);
  const { inventoryId } = useParams();

  useEffect(() => {
    const seller_id = searchParams.get("seller_id") || "";
    const status = searchParams.get("status") || "";

    if (seller_id !== filters.seller_id || status !== filters.status) {
      dispatch(setInventorySpareLotListFilter({ seller_id, status }));
    }
  }, [searchParams, filters.seller_id, filters.status, dispatch]);

  /* =====================
     FILTER HANDLER
  ===================== */
  const updateFilterParams = useCallback(
    (key, value) => {
      const params = new URLSearchParams(searchParams);
      value ? params.set(key, value) : params.delete(key);
      setSearchParams(params);
    },
    [searchParams, setSearchParams],
  );

  const handleSelection = (key, value) => {
    updateFilterParams(key, value);
  };

  return (
    <div className={classes.box}>
      <h1 className={classes.box__title}>
        Inventory Variant List: {inventoryId}
      </h1>

      <div className={classes.box__content}>
        <div className={classes.box__content__filter}>
          <CustomDropdown
            id="status"
            label="Select Status"
            options={statuses}
            selectedId={filters.status || ""}
            onSelection={handleSelection}
          />
        </div>
      </div>
    </div>
  );
};
